const WiseTransferMethodEnum = {
  SourceCurrency: 'SourceCurrency',
  TargetCurrency: 'TargetCurrency',
};

export default WiseTransferMethodEnum;
